import { t } from "i18next";
import { MouseEventHandler } from "react";
import { Button, Modal } from "react-bootstrap";

interface Context {
  showModal: boolean;
  setShowModal: (showModal: boolean) => MouseEventHandler;
  loading: boolean;
  showFooter?: boolean;
}

interface ModalConfig {
  title: string;
  contextInstance: any;
  onSubmit?: any;
  customShowModal?: boolean;
  customSetShowModal?: any;
  size?: string;
  fullscreen?: string | true;
}

interface Props {
  modalConfig: ModalConfig;
  children: React.ReactNode;
}

function CrudModuleFactoryModal(props: Props) {
  const {
    title,
    contextInstance,
    onSubmit,
    customShowModal,
    customSetShowModal,
    size,
    fullscreen,
  } = props.modalConfig;
  const { children } = props;
  const { showModal, setShowModal, loading, showFooter } = contextInstance;
  const handleClose = () => {
    if (customSetShowModal != undefined) {
      customSetShowModal(false);
      return;
    }
    setShowModal(false); // We pass the function to close the modal on success
  };
  const onSubmitFunction = () => {
    onSubmit();
  };
  const showModalValue =
    customShowModal != undefined ? customShowModal : showModal;
  return (
    <Modal show={showModalValue} onHide={handleClose} className={size} fullscreen={fullscreen}>
      <Modal.Header closeButton>
        <Modal.Title as="div">{t(title)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {showFooter ||
        (showFooter === undefined && (
          <Modal.Footer>
            <Button variant="light" className="close" onClick={handleClose}>
              {t("close")}
            </Button>
            <Button
              variant="primary"
              disabled={loading}
              onClick={onSubmitFunction}
            >
              {t("save_changes")}
            </Button>
          </Modal.Footer>
        ))}
    </Modal>
  );
}

export default CrudModuleFactoryModal;
